import { useMemo } from "react";
import { coordsToMatrix } from "./main9.mjs";
function useCoords({ latitude, longitude, altitude, fromLngLat }) {
  const m4 = useMemo(() => coordsToMatrix({
    latitude,
    longitude,
    altitude,
    fromLngLat
  }), [latitude, longitude, altitude, fromLngLat]);
  return m4;
}
export {
  useCoords
};
//# sourceMappingURL=main7.mjs.map
